import { render, staticRenderFns } from "./costProductList.vue?vue&type=template&id=a03d5ca8&scoped=true&"
import script from "./costProductList.vue?vue&type=script&lang=js&"
export * from "./costProductList.vue?vue&type=script&lang=js&"
import style0 from "./costProductList.vue?vue&type=style&index=0&id=a03d5ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03d5ca8",
  null
  
)

export default component.exports